module.exports = __webpack_public_path__ + "img/icon_5_95.51d35e5a.png";